__turbopack_context__.v({
  "photo_gallery__photo": "GalleryPhoto-module-scss-module__No9hzq__photo_gallery__photo",
  "photo_gallery__photo_wrapper": "GalleryPhoto-module-scss-module__No9hzq__photo_gallery__photo_wrapper",
});
